import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { ClassificationsPage } from './_dashboard.catalog.classifications'

export const Route = createFileRoute('/_dashboard/catalog/classifications/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ClassificationsIndexPage,
})

function ClassificationsIndexPage() {
  return <ClassificationsPage selectedId={undefined} />
}
